<template>
    <header class="top-header">
        <div class="nav-left">
            <router-link to="/" class="brand-container" style="text-decoration: none;">
                <img src="@/assets/icons/iconApp.svg" alt="App" class="app-svg" />
                <h3 class="app-name">{{ AppEssentials.AppName }}</h3>
            </router-link>
            <nav class="main-nav">
                <router-link to="/" exact-active-class="active">Home</router-link>
                <a @click="onVoiceGallery">Voice Gallery</a>
                <a @click="onVoiceDesigner">Voice Designer</a>
                <a @click="onTTS">Text To Speech</a>
                <router-link to="/pricing" active-class="active">Pricing</router-link>
                <router-link to="/about" active-class="active">About</router-link>
            </nav>
        </div>
        <div class="nav-right">
            <nav class="user-nav">
                <template v-if="!isAuthenticated">
                    <a href="#" class="nav-link" @click.prevent="handleLogin">Login</a>
                    <a href="#" class="nav-link" @click.prevent="handleRegister">Register</a>
                </template>
                <template v-else>
                    <div class="user-menu" ref="menuRef" @click="toggleDropdown">
                        <button class="user-btn">
                            {{ username }}
                            <span class="arrow" :class="{ open: dropdown }">▼</span>
                        </button>
                        <ul v-if="dropdown" class="dropdown">
                            <li @click="goToProfile">Profile</li>
                            <li @click="goToCredit">Credit</li>
                            <li @click="goToReferral">Referral</li>
                            <li @click="handleLogout">Logout</li>
                        </ul>
                    </div>
                </template>
            </nav>
        </div>
    </header>
</template>

<script>
import AppEssentials from '@/data/AppEssentials.js'
import { useRouter } from 'vue-router';
import { inject, ref, onMounted, onUnmounted, computed } from 'vue'
import { logout } from '@/api/auth'
export default {
    name: "TopHeader",
    setup() {
        const router = useRouter();
        const keycloak = inject('keycloak')
        const dropdown = ref(false)
        const menuRef = ref(null)
        const username = ref('')
        const authToken = ref('')

        const isAuthenticated = computed(() => {
            return authToken.value && authToken.value !== ''
        })

        onMounted(() => {
            checkAuthStatus()
            window.addEventListener('storage', checkAuthStatus)
            document.addEventListener('click', onClickOutside)
        })
        onUnmounted(() => {
            document.removeEventListener('click', onClickOutside)
        })

        function checkAuthStatus() {
            authToken.value = localStorage.getItem('auth_token') || ''
            username.value = localStorage.getItem('username') || 'User'
        }

        function toggleDropdown() {
            dropdown.value = !dropdown.value
        }

        function onClickOutside(e) {
            if (menuRef.value && !menuRef.value.contains(e.target)) {
                dropdown.value = false
            }
        }
        function handleLogin() {
            keycloak.login()
        }
        function handleRegister() {
            keycloak.register()
        }
        function handleLogout() {
            logout()
        }
        function goToProfile() {
            router.push({ path: '/profile' });
        }
        function goToCredit() {
            router.push({ path: '/credit' });
        }
        function goToReferral() {
            router.push({ path: '/referral' });
        }
        function onVoiceGallery() {
            if (!isAuthenticated.value) {
                keycloak.login()
                return;
            }
            router.push({ path: '/voice-gallery' });
        }
        function onVoiceDesigner() {
            if (!isAuthenticated.value) {
                keycloak.login()
                return;
            }
            router.push({ path: '/voice-designer' });
        }
        function onTTS() {
            if (!isAuthenticated.value) {
                keycloak.login()
                return;
            }
            router.push({ path: '/text-to-speech-projects' });
        }

        return {
            AppEssentials,
            username,
            dropdown,
            menuRef,
            isAuthenticated,
            goToProfile,
            goToCredit,
            goToReferral,
            toggleDropdown,
            handleLogin,
            handleRegister,
            handleLogout,
            onVoiceGallery,
            onVoiceDesigner,
            onTTS,
        }
    }
}
</script>

<style scoped>
.top-header {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    width: 100%;
    background: rgba(255, 255, 255, 0.72);
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 24px;
    padding: 0 clamp(16px, 4vw, 42px);
    min-height: 56px;
    box-shadow: 0 8px 26px rgba(17, 17, 20, 0.04);
    z-index: 1000;
    border-bottom: 1px solid rgba(17, 17, 20, 0.08);
    margin: 0;
    backdrop-filter: blur(18px) saturate(1.25);
}

.nav-left {
    min-width: 0;
    display: flex;
    align-items: center;
    gap: clamp(18px, 3vw, 36px);
}

.brand-container {
    display: flex;
    align-items: center;
    gap: 8px;
}

.app-svg {
    width: 28px;
    height: 28px;
    display: block;
    transition: filter 0.3s, color 0.3s;
    filter: var(--purple-filter)
}

.app-name {
    font-size: 22px;
    font-weight: 700;
    color: #222;
}

.main-nav {
    display: flex;
    align-items: center;
    gap: clamp(16px, 2.2vw, 32px);
}

.main-nav a {
    color: #222;
    text-decoration: none;
    padding: 0 4px;
    transition: color 0.2s;
    font-size: 14px;
    cursor: pointer;
}

.main-nav a.active,
.main-nav a:hover {
    color: var(--purple);
}

.nav-right {
    flex: 0 0 auto;
    display: flex;
    align-items: center;
    gap: 18px;
}

.user-nav {
    display: flex;
    align-items: center;
    gap: 18px;
}

.user-nav .nav-link,
.user-nav a {
    color: #222;
    text-decoration: none;
    font-size: 14px;
    padding: 0 4px;
    transition: color 0.2s;
    cursor: pointer;
    background: none;
    border: none;
    outline: none;
    font-family: inherit;
    display: flex;
    align-items: center;
}

.user-nav .nav-link:hover,
.user-nav .nav-link:focus,
.user-nav a:hover,
.user-nav a:focus {
    color: var(--purple);
}

.user-menu {
    position: relative;
}

.user-btn {
    background: none;
    border: none;
    font-weight: 500;
    color: var(--text-secondary, #6b6f7a);
    cursor: pointer;
    display: flex;
    align-items: center;
    font: inherit;
    gap: 8px;
    text-decoration: none;
    max-width: min(32vw, 280px);
    overflow-wrap: anywhere;
    text-align: left;
    white-space: normal;
    line-height: 1.2;
}

.user-btn .arrow {
    transition: transform 0.2s;
}

.user-btn .arrow.open {
    transform: rotate(180deg);
}

.dropdown {
    position: absolute;
    top: calc(100% + 10px);
    right: 0;
    margin: 0;
    list-style: none;
    display: flex;
    flex-direction: column;
    background: #fff;
    border: 1px solid #eee;
    border-radius: 10px;
    box-shadow: 0 18px 44px rgba(17, 17, 20, 0.12);
    min-width: 154px;
    z-index: 1000;
}

.dropdown li {
    margin: 0;
    padding: 0.75rem 1rem;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
}

.dropdown li:hover {
    background-color: #f5f5fa;
}

@media (max-width: 920px) {
    .top-header {
        padding-inline: 18px;
    }

    .main-nav {
        gap: 16px;
    }

    .main-nav a:nth-last-child(-n + 2) {
        display: none;
    }
}

@media (max-width: 640px) {
    .top-header {
        min-height: 54px;
    }

    .app-name {
        font-size: 20px;
    }

    .app-svg {
        width: 28px;
        height: 28px;
    }

    .main-nav {
        display: none;
    }

    .user-btn {
        max-width: 44vw;
    }
}
</style>
